import Vue from 'vue'
import Vuex from 'vuex'

import browser from './browser'
//import wechat from './wechat'
import app from './app'
import shop from './shop'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    browser: browser,
    //wechat: wechat,
    app: app,
    shop: shop,
  },
  strict: process.env.NODE_ENV !== 'production',
})

if (module.hot) {
  module.hot.accept(['./browser', './app'], () => {
    store.hotUpdate({
      modules: {
        browser: require('./browser'),
        app: require('./app'),
        shop: require('./shop'),
      },
    })
  })
}

export default store
